
var ScrollMixin = {
  data () {
    return {
      scrolled: false,
      reachedEnd: false,
      almostReachedEnd: false,
      isFirstScreen: true,
      scrollSpeed: 1200,
      currentScreen: 0
    }
  },
  computed: {
    wrapWidth () {
      return (window.innerWidth * this.numSlides);
    },
    mainWrapper () {
      return document.getElementById(this.mainElementId)
    },
    offseters () {
      return document.getElementsByClassName(this.offseterId)
    }
  },
  mounted () {
    this.startScroll()
    document.body.addEventListener('touchstart', function(e){ e.preventDefault(); });
  },
  methods: {
    startScroll () {
      this.handleScroll()
      this.mainWrapper.addEventListener('scroll', this.handleScroll)

      var slides = document.getElementsByClassName('slide');
      Array.from(slides).forEach((slide) => {
        slide.style.width = window.innerWidth + 'px'
      })
      /*
      setInterval(() => {
        this.handleScroll()
      }, 5)*/
      this.currentScreen = 0
    },
    handleScroll () {
      Array.from(this.offseters).forEach(offseter => {
        offseter.style.backgroundPositionX = '-' + (this.mainWrapper.scrollLeft * offseter.dataset.speed) + 'px'
      })
      if (this.mainWrapper.scrollLeft >= this.minTitleScroll) {
        this.scrolled = true
      } else {
        this.scrolled = false
      }

      if (this.mainWrapper.scrollLeft <= 50) {
        this.isFirstScreen = true
      } else {
        this.isFirstScreen = false
      }

      if (this.mainWrapper.scrollLeft >= this.wrapWidth - window.innerWidth - 50) {
        this.almostReachedEnd = true
        setTimeout(() => {
          this.reachedEnd = true
        }, 0)
      } else {
        this.reachedEnd = false
        this.almostReachedEnd = false
      }

    },
    nextScreen () {
      // let s = Math.floor(this.mainWrapper.scrollLeft / window.innerWidth)

      this.currentScreen++
      if (this.currentScreen > this.numSlides) {
        this.currentScreen = this.numSlides
      }
      let s = this.currentScreen

      console.log(s)

      $(this.mainWrapper).animate({
        scrollLeft: (s) * window.innerWidth
      }, this.scrollSpeed)
    },
    prevScreen () {
      // let s = Math.floor(this.mainWrapper.scrollLeft / window.innerWidth)

      this.currentScreen--
      if (this.currentScreen < 0) {
        this.currentScreen = 0
      }

      let s = this.currentScreen

      $(this.mainWrapper).animate({
        scrollLeft: (s) * window.innerWidth
      }, this.scrollSpeed)
    },
    firstScreen () {
      $(this.mainWrapper).animate({
        scrollLeft: 0
      }, (this.scrollSpeed * this.numSlides) * .5)
    }
  }
}

export default ScrollMixin
